import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type DialogActionsElement = FlexElement;

export interface DialogActionsProps extends FlexProps {
  disableSpacing?: boolean;
}

export const DialogActions = styled(Flex).withConfig({
  shouldForwardProp: (prop) => !['disableSpacing'].includes(prop),
  displayName: 'DialogActions',
})<DialogActionsProps>`
  display: flex;
  align-items: center;
  padding: 8;
  justify-content: flex-end;
  flex: 0 0 auto;
  flex-direction: row;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 24px;
  ${({ disableSpacing }) => (!disableSpacing ? `& > :not(:first-child) { margin-left: 8px; }` : '')}
`;
